import { useEffect } from 'react';
import { useRouter } from 'next/router';

export const useUTMParams = () => {
  const router = useRouter();

  useEffect(() => {
    const { query } = router;

    Object.entries(query).forEach(([key, value]) => {
      if (!key.startsWith('utm') || Array.isArray(value)) return;
      sessionStorage.setItem(key, value);
    });
  }, [router.query]);

  useEffect(() => {
    const loadUtmParameters = e => {
      if (e.data.type !== 'hsFormCallback' || e.data.eventName !== 'onReady') return;

      const utmCookies = Object.entries(sessionStorage).filter(([key]) => key.startsWith('utm'));

      utmCookies.forEach(([key, value]) => {
        const utmInput = document.querySelector<HTMLInputElement>(`input[name=${key}]`);
        if (!utmInput) return;
        utmInput.value = value;
      });
    };

    window.addEventListener('message', loadUtmParameters);

    return () => {
      window.removeEventListener('message', loadUtmParameters);
    };
  }, []);
};
